import React, { useState } from 'react'
import s from './tabs.module.scss'
import cx from 'classnames'

type Tab = {
  id: string
  text: React.ReactNode
  content: React.ReactNode
  hidden?: boolean
}

type Props = {
  tabs: Tab[]
  defaultTab?: string
}

export const TabsV3 = ({ tabs, defaultTab }: Props) => {
  const [activeTab, setActiveTab] = useState(defaultTab || tabs[0]?.id)
  const activeTabContent = tabs.find((tab) => tab.id === activeTab)

  return (
    <>
      <div className={s.tabs}>
        {tabs.map((tab) => {
          if (tab.hidden) return null
          return (
            <button
              key={tab.id}
              className={cx({ [s.active]: activeTab === tab.id }, s.tab)}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.text}
            </button>
          )
        })}
      </div>

      {activeTabContent && activeTabContent.content}
    </>
  )
}
